// extracted by mini-css-extract-plugin
module.exports = {"details":"MediaDetails_details__V1G_8","title":"MediaDetails_title__geIaw","small":"MediaDetails_small__4wlu7"};